import styled from '@emotion/styled';

export const Spacer = styled.div`
  height: ${({ theme }) => theme.spacing[40]};
`;
